module.exports = __webpack_public_path__ + "a9049c96d73536296f2432117e34afb9.png";